import {VueController} from '@/service/support/vuex-controller';
import SettingsItem from '@/components/SettingsItem';
import StripePayment from "@/components/StripePayment";
import ApiSettings from "@/components/ApiSettings";
import WebhookSettings from "@/components/WebhookSettings";
import TaxiSettings from "@/components/TaxiSettings";
import orgService from "@/service/org-service";
import PlanSelection from "@/components/PlanSelection";
import {EventBus} from '@/service/support/event-bus';
import stripeService from "@/service/stripe-service";
import moment from 'moment';

import * as awsVars from '@/config/aws-exports';
import vaultService from "@/service/vault-service";
let awsmobile = awsVars.default(process.env);

const usdFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2
});

export default VueController("Settings", {
	state: [
		"organization",
		"organizationId",
		"members",
		"cognito",
		"user",
		"newOrganizationTier",
		"stripeDiscount",
		"subscriptionPlanOptions",
		"stripeInterval"
	],
	data() {
		return {
			headers: [
				{
					text: "Name",
					align: 'start',
					sortable: true,
					value: 'displayName'
				},
				{
					text: "Email",
					value: 'email'
				},
				{
					text: "Access Portals",
					value: "access_vault"
				},
				{
					text: "Create Portals",
					value: "create_vault"
				},
				{
					text: "Manage Permissions",
					value: "manage_perms"
				},
				{
					text: "View Files",
					value: "view_files"
				},
				{
					text: "Rename Files",
					value: "rename_files"
				},
				{
					text: "Delete Files",
					value: "delete_files"
				},
				{
					text: "Upload Files",
					value: "upload_files"
				},
				{
					text: "Notify Upload",
					value: "upload_notification"
				},
				{
					text: "Notify Download",
					value: "download_notification"
				},
				{
					text: "Edit Settings",
					value: "edit_settings"
				},
				{
					text: "Manage Members",
					value: "manage_members"
				},
				{
					text: "Actions",
					value: "actions"
				}
			],
			templateHeaders: [
				{
					text: "Template Name",
					align: 'start',
					sortable: true,
					value: 'name'
				},
				{
					text: "Created Date",
					value: 'createdAt',
					sortable: true
				},
				{
					text: "Last Modified",
					value: '_lastChangedAt',
					sortable: true
				},
				{
					text: "Actions",
					value: 'actions',
					sortable: false,
					align: 'center'
				}
			],
			cancelReasons: [
				{reason : "Price"},
				{reason : "Missing Features"},
				{reason : "Complicated to use"},
				{reason : "Other"}
			],
			addMemberError: "",
			addMemberAlert: false,
			memberSearch: "",
			memberToDelete: "",
			cancelComments: "",
			cancelSelection: "",
			paymentStepper: 1,
			perms: [],
			tabs: 1,
			linkIsEmbedded: false,
			promoCodeFailed: false,
			promoCodeValid: false,
			promoCode: "",
			promoDetails: "",
			updateToTier: "",
			stripeSubId: "",
			stripeStatus: "",
			stripeNextPayment: "",
			stripeStartDate: "",
			stripeLastFour: "",
			stripeBillingAmount: "",
			stripeNextInvoiceAmount: "",
			stripeNextInvoiceProration: "",
			stripeNextInvoiceBase: "",
			stripeTrialEndDate: "",
			stripeCardBrand: "",
			stripeCardExpiration: "",
			updateStripeCard: false,
			loading: true,
			invoices: [],
			openSubscriptionTab: false,
			tabIndex: [0, 0],
			labelIcon: {
				dataOn: '\u2713',
				dataOff: '\u2715'
			},
			modals: {
				switchPeriod: false,
				organizationProfile: false,
				passwordRequirements: false,
				deviceApprovals: false,
				sessionLength: false,
				memberDelete: false,
				addMember: false,
				planSelect: false,
				changeCard: false,
				cancelStripe: false,
				createTemplate: false,
				deleteTemplate: false,
				archiveTemplate: false,
				createPortalFromTemplate: false,
				deleteWorkflowStateWarning: false,
				workflowDialog: false,
				deleteWorkflowDialog: false
			},
			progress: {
				cancelStripe: false,
				switchPeriod: false,
				organizationProfile: false,
				passwordRequirements: false,
				deviceApprovals: false,
				memberDelete: false,
				sessionLength: false,
				addMember: false,
				planSelect: false,
				changeCard: false,
				createTemplate: false,
				deleteTemplate: false,
				archiveTemplate: false,
				createPortalFromTemplate: false
			},
			newMemberName: "",
			newMemberEmail: "",
			templateName: "",
			templateToDelete: null,
			templateToArchive: null,
			selectedTemplateForPortal: null,
			newPortalFromTemplate: {
				name: '',
				tagsRaw: ''
			},
			logoFileData: null,
			logoBucket: null,
			redirectReason: "",
			emailChangedFlag: false,
			emailSaving: false,
			replyToSaving: false,
			replyToEmail: "",
			buttonSaving: {
				updateLogo: false,
				updateCompanyName: false,
				updateReplyTo: false,
				updateEnforceTerms: false,
				updateWorkflowStates: false,
				updateBranding: false,
				updateEmailTemplates: false,
				updateSubdomain: false,
				updateMfaRequirement: false,
				updateAiFileNaming: false,
				saveWorkflow: false,
				saveExternalSystems: false
			},
			newExternalSystem: '',
			requireMfaForVaultAccess: false,
			aiFileNamingEnabled: true,
			subdomain: "",
			originalSubdomain: "",
			subdomainAvailable: null,
			checkingSubdomain: false,
			subdomainError: "",
			subdomainCheckTimeout: null,
			emailTemplates: {
				guestInvite_subject: '',
				guestInvite_header: '',
				guestInvite_body: '',
				memberInvite_subject: '',
				memberInvite_body: '',
				taskReminder_subject: '',
				taskReminder_intro: '',
				taskReminder_closing: '',
				notification_subject: '',
				notification_body: '',
				magicLink_subject: '',
				magicLink_body: '',
				magicLink_expiry: ''
			},
			defaultEmailTemplates: {
				guestInvite: {
					subject: '{{orgName}} has invited you to a secure file portal - Accept before {{expirationDate}}',
					header: '{{userName}} from {{orgName}} has a file sharing portal for you to access. Click below to accept your invitation and create an account.',
					body: 'This file sharing portal will allow you to quickly and securely exchange files with {{orgName}}. Not signed up? Don\'t worry, creating an account is easy. Simply click the link above, choose a password and that\'s it!'
				},
				memberInvite: {
					subject: '{{orgName}} has invited you as a Team Member of Zapa Client Portals!',
					body: '{{userName}} from {{orgName}} has created a member account for you to access Zapa Client Portals.'
				},
				taskReminder: {
					subject: 'Reminder: {{portalName}} - {{orgName}}',
					intro: 'We\'d like to remind you that you have {{taskCount}} upcoming tasks due.',
					closing: 'To answer questions, upload files, or update your task status, please access your portal.'
				},
				notification: {
					subject: 'Portal Notification: {{action}} ({{portalName}})',
					body: '{{userName}} {{action}} in portal {{portalName}}.'
				},
				magicLink: {
					subject: 'Temporary Zapa Client Portal - Magic Login Link',
					body: 'This is your passwordless magic login link to Zapa Client Portals. This link will expire in {{expiryMinutes}} minutes.',
					expiry: 'This link will expire in only 3 minutes, after which time you will need to request a new link.'
				}
			},
			rules: {
				required: value => !!value || 'Required.',
				email: value => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					return pattern.test(value) || 'Invalid e-mail.'
				},
			},
			customEmailBody: "This file sharing portal will allow you to quickly and securely exchange files with {{orgName}}. Not signed up? Don't worry, creating an account is easy. Simply click the link above, choose a password and that's it!",
			customEmailHeading: '{{userName}} from {{orgName}} has a file sharing portal for you to access. Click below to accept your invitation and create an account.',
			customEmailSubject: "{{orgName}} has invited you to a secure file portal - Accept before {{expirationDate}}",
			templates: [],
			showArchivedTemplates: false,
			workflowStatesEnabled: false,
			workflowStates: [
				{ id: 1, name: "Intake" },
				{ id: 2, name: "In Progress" },
				{ id: 3, name: "Under Review" },
				{ id: 4, name: "Complete" }
			],
			workflowStateToDelete: null,
			vaultsUsingWorkflowState: [],
			// New multi-workflow system
			workflows: [],
			selectedWorkflow: null,
			editingLegacyWorkflow: false,
			workflowFormValid: false,
			editingWorkflow: {
				name: '',
				description: '',
				states: []
			},
			workflowToDelete: null,
			vaultsUsingWorkflow: [],
			hideZapaLogo: false,
		primaryBrandColor: '#0d7542',
		primaryBrandColorName: 'Emerald',
		brandColorOptions: [
			{ name: 'Zapa Green (Default)', hex: '#0d7542' },
			{ name: 'Turquoise', hex: '#1abc9c' },
			{ name: 'Green Sea', hex: '#16a085' },
			{ name: 'Emerald', hex: '#2ecc71' },
			{ name: 'Nephritis', hex: '#27ae60' },
			{ name: 'Peter River', hex: '#3498db' },
			{ name: 'Belize Hole', hex: '#2980b9' },
			{ name: 'Amethyst', hex: '#9b59b6' },
			{ name: 'Wisteria', hex: '#8e44ad' },
			{ name: 'Wet Asphalt', hex: '#34495e' },
			{ name: 'Midnight Blue', hex: '#2c3e50' },
			{ name: 'Orange', hex: '#f39c12' },
			{ name: 'Carrot', hex: '#e67e22' },
			{ name: 'Pumpkin', hex: '#d35400' },
			{ name: 'Alizarin', hex: '#e74c3c' },
			{ name: 'Pomegranate', hex: '#c0392b' },
			{ name: 'Concrete', hex: '#95a5a6' },
			{ name: 'Asbestos', hex: '#7f8c8d' },
			{ name: 'Crimson', hex: '#dc143c' },
			{ name: 'Navy', hex: '#001f3f' },
			{ name: 'Teal', hex: '#39cccc' },
			{ name: 'Olive', hex: '#3d9970' },
			{ name: 'Lime', hex: '#01ff70' },
			{ name: 'Fuchsia', hex: '#f012be' },
			{ name: 'Maroon', hex: '#85144b' },
			{ name: 'Blue', hex: '#0074d9' },
			{ name: 'Aqua', hex: '#7fdbff' },
			{ name: 'Purple', hex: '#b10dc9' },
			{ name: 'Gray', hex: '#aaaaaa' },
			{ name: 'Black', hex: '#111111' }
		],
			// Template variable examples (these are just for display in the UI as examples)
			orgName: '{{orgName}}',
			userName: '{{userName}}',
			portalName: '{{portalName}}',
			expirationDate: '{{expirationDate}}',
			taskCount: '{{taskCount}}',
			dueDate: '{{dueDate}}',
			fileName: '{{fileName}}',
			magicCode: '{{magicCode}}',
			expiryMinutes: '{{expiryMinutes}}'
		}
	},
	components: {
		SettingsItem,
		StripePayment,
		PlanSelection,
		ApiSettings,
		WebhookSettings,
		TaxiSettings
	},
	computed: {
		isCurrentUserAdmin() {
			return this.cognito && this.cognito.attributes && this.cognito.attributes['custom:mutableUserType'] === 'admin';
		},
		currentUserPermissions() {
			if (!this.organization || !this.organization.permissions || !this.cognito || !this.cognito.attributes) {
				return {};
			}
			const perm = this.organization.permissions.find(p => 
				p.user_email === this.cognito.attributes.email && p._deleted !== 1
			);
			return perm || {};
		},
		canEditSettings() {
			return this.isCurrentUserAdmin || this.currentUserPermissions.edit_settings === true;
		},
		canManageMembers() {
			return this.isCurrentUserAdmin || this.currentUserPermissions.manage_members === true;
		},
		canAccessSettings() {
			return this.isCurrentUserAdmin || this.canEditSettings || this.canManageMembers;
		},
		subdomainBaseDomain() {
			// Derive the base domain from the environment's hosting URL
			// (e.g., https://app.zapaportal.com -> zapaportal.com) so the
			// displayed subdomain URL is correct in every environment.
			let hostingUrl = awsmobile.hosting_url || "";
			let host = hostingUrl.replace(/^https?:\/\//, "");
			return host.replace(/^(app|www)\./, "");
		},
		promoDescription() {
			if (this.promoCodeDetails) {
				if (this.promoCodeDetails.coupon.name) {
					return this.promoCodeDetails.coupon.name;
				}
			}
		},
		canShowTemplatesTab() {
			if (!this.canEditSettings) {
				return false;
			}
			const tier = this.organization ? this.organization.tier : '';
			return tier === 'enterprise' || tier === 'large firm';
		},
		subscriptionTabIndex() {
			// Tabs are conditionally rendered, so the Subscription tab's index is
			// the count of visible tabs before it (Templates, Manage Users).
			return (this.canShowTemplatesTab ? 1 : 0) + (this.canManageMembers ? 1 : 0);
		},
		nextInvoiceDetail() {
			if (!this.stripeNextInvoiceProration || !this.stripeNextInvoiceBase) {
				return "";
			}
			if (this.stripeNextInvoiceProration.indexOf("-") > -1) {
				return this.stripeNextInvoiceBase + " subscription − " + this.stripeNextInvoiceProration.replace("-", "") + " prorated plan change credit";
			}
			return this.stripeNextInvoiceBase + " subscription + " + this.stripeNextInvoiceProration + " prorated plan changes";
		},
		isEnterpriseTier() {
			return this.organization && this.organization.tier === 'enterprise';
		},
		hasNoActivePlan() {
			const tier = this.organization ? this.organization.tier : '';
			return !tier || tier === 'null';
		},
		enterpriseContactUrl() {
			// Enterprise is sales-assisted (not self-serve). Matches the
			// "Contact Us to Upgrade" convention used elsewhere in settings.
			return "mailto:support@zapaportal.com?subject=Enterprise Plan Inquiry";
		},

		planDescription() {
			let lowerCase = this.organization.tier.toLowerCase();
			let tierDescription = '';
			switch (lowerCase) {
				case "starter":
					tierDescription = "Basic Plan, Limited to 1 User, Maximum of 50 client portals, 500GB Storage";
					break;
				case "professional":
					tierDescription = "Professional Plan, Unlimited Users, Maximum of 1,000 client portals, 1TB Storage";
					break;
				case "large firm":
				case "advanced":
					tierDescription = "Large Business Plan, Unlimited Users, Maximum of 10,000 client portals, 10TB Storage";
					break;
				case "enterprise":
					tierDescription = "Corporate Plan, Unlimited Users, Unlimited Client Portals, Unlimited Data";
					break;
			}
			return tierDescription;
		},
		planPriceEstimate() {
			let planTier = this.planTitle(this.organization.tier);
			let planDetails = this.subscriptionPlanOptions.find(plan => plan.title === this.organization.tier);
			if (!planDetails) {
				return `You have elected the ${planTier} plan.`;
			}
			let planPrice = planDetails.price[this.stripeInterval.toLowerCase() === "month" ? "monthly" : "yearly"];
			if (this.stripeInterval.toLowerCase() !== "month") {
				planPrice = "$" + (Number(planPrice.replace('$', '')) * 12);
			}
			return `You have elected the ${planTier} plan to be billed at ${planPrice}.00 on a ${this.stripeInterval}ly basis.`;
		},
		filteredTemplates() {
			if (!this.templates) return [];
			
			if (this.showArchivedTemplates) {
				// Show all templates (including archived)
				return this.templates;
			} else {
				// Show only non-archived templates
				return this.templates.filter(template => !template.archived);
			}
		},
		
		// Combined workflows list: includes default/legacy workflow + new workflows
		allWorkflows() {
			const combined = [];
			
			// Add default/legacy workflow if it exists
			if (this.organization && this.organization.workflowStates && this.organization.workflowStates.length > 0) {
				combined.push({
					id: 'default',
					name: 'Default Workflow',
					description: 'Legacy organization-level workflow (can be disabled in settings)',
					states: this.organization.workflowStates,
					is_default: true,
					isLegacy: true,
					created_at: this.organization.createdAt || new Date().toISOString()
				});
			}
			
			// Add new workflows
			if (this.workflows && this.workflows.length > 0) {
				combined.push(...this.workflows);
			}
			
			return combined;
		}
	},
	methods: {
		canManageThisMember(member) {
			if (!this.canManageMembers) return false;
			if (this.isCurrentUserAdmin) return true;
			// Non-admin with manage_members permission
			if (member.administratorOf === this.organization.id) return false; // Can't edit admin
			if (member.email === this.cognito.attributes.email) {
				// Can't edit own manage_members permission (prevent self-lockout)
				return false;
			}
			return true;
		},
		orgLoginURL(embedded) {
			return `${awsmobile.hosting_url}/signin?org=${this.organization && this.organization.id ? this.organization.id : ""}&embedded=${embedded}`;
		},
		planTitle(planId) {
			let planName = "Team";
			if (typeof planId === "string") {
				switch (planId.toLowerCase()) {
					case "starter":
						planName = "Starter";
						break;
					case "professional":
						planName = "Professional"
						break;
					case "large firm":
					case "advanced":
						planName = "Large Firm";
						break;
					case "enterprise":
						planName = "Enterprise";
						break;
					case "canceled":
						planName = "Cancelled";
						break;
				}
			} else {
				planName = "";
			}

			return planName;
		},
		renderEmailText(value, splitOnNewline) {
			let self = this;
			let updatedValue = value;
			let today = new Date();
			today.setDate(today.getDate() + 30);
			let terms = [
				{ token: "orgName", value: self.organization.companyName },
				{ token: "userName", value: self.user.displayName },
				{ token: "portalName", value: "John Doe" },
				{ token: "expirationDate", value: today.toLocaleDateString()}
			];

			for (let i = 0; i < terms.length; i++) {
				let term = terms[i];
				updatedValue = updatedValue.replaceAll("{{" + term.token + "}}", term.value);
				updatedValue = updatedValue.replaceAll("{{ " + term.token + " }}", term.value);
			}

			if (splitOnNewline) {
				return updatedValue.split('\n');
			} else {
				return updatedValue;
			}
		},
		usd(value) {
			return usdFormatter.format(value);
		},
		momentDate(timestamp) {
			return moment(timestamp * 1000).format("MM/DD/YYYY");
		},
		formatDate(timestamp) {
			// Handle Unix timestamps, milliseconds, and ISO strings
			if (!timestamp) return 'N/A';
			
			try {
				let date;
				
				// If it's a string (ISO format), use it directly
				if (typeof timestamp === 'string') {
					date = moment(timestamp);
				} else {
					// If timestamp is in seconds (like most AWS timestamps), convert to milliseconds
					const timestampMs = timestamp < 10000000000 ? timestamp * 1000 : timestamp;
					date = moment(timestampMs);
				}
				
				return date.isValid() ? date.format("MM/DD/YYYY") : 'N/A';
			} catch (error) {
				console.error('Error formatting date:', error);
				return 'N/A';
			}
		},
		getLastModifiedDate(item) {
			// First try to get a valid last modified date
			if (item._lastChangedAt) {
				const formattedDate = this.formatDate(item._lastChangedAt);
				// Check if the date is valid and not the default 01/01/2000
				if (formattedDate !== 'N/A' && formattedDate !== '01/01/2000') {
					return formattedDate;
				}
			}
			
			// Fallback to created date if last modified is invalid or missing
			if (item.createdAt) {
				const formattedDate = this.formatDate(item.createdAt);
				if (formattedDate !== 'N/A') {
					return formattedDate;
				}
			}
			
			// If neither date is available or valid, return empty string
			return '';
		},
		getCardIcon(cardBrand) {
			// Map card brands to appropriate Font Awesome Pro icons
			const brandMap = {
				'visa': 'fab fa-cc-visa',
				'mastercard': 'fab fa-cc-mastercard',
				'amex': 'fab fa-cc-amex',
				'discover': 'fab fa-cc-discover',
				'diners': 'fab fa-cc-diners-club',
				'jcb': 'fab fa-cc-jcb',
				'unionpay': 'far fa-credit-card'
			};
			
			// Convert to lowercase for case-insensitive matching
			const brand = (cardBrand || '').toLowerCase();
			
			// Return the mapped icon or a default icon
			return brandMap[brand] || 'far fa-credit-card';
		},
		copyText(){
			document.getElementById("brandedLink").select();
			document.execCommand('copy');
		},
		saveCompanyName() {
			this.buttonSaving.updateCompanyName = true;
			orgService.mutation("updateCompanyName", {
				"company_name": this.organization["companyName"]
			}).then(response => {
				this.modals.organizationProfile = false;
				this.buttonSaving.updateCompanyName = false;
			}).catch(error => {
				console.error("Unable to update company name.");
				this.buttonSaving.updateCompanyName = false;
			});
		},
		updateEnforceTerms() {
			this.buttonSaving.updateEnforceTerms = true;
			//console.log("Updated ORG: " + JSON.stringify(this.organization));
			orgService.mutation("updateOrganizationBoolean", {
				"field": "termsEnforced",
				"value": this.organization["termsEnforced"],
				"terms": this.organization["termsAndConditions"]
			}).then(response => {
				this.buttonSaving.updateEnforceTerms = false;
			}).catch(error => {
				console.error("Unable to update organization preference.");
				this.buttonSaving.updateEnforceTerms = false;
			});
		},
		
		// External Systems Management
		addExternalSystem() {
			if (!this.newExternalSystem || !this.newExternalSystem.trim()) {
				return;
			}
			
			const systemName = this.newExternalSystem.trim();
			
			// Initialize externalSystems array if it doesn't exist
			if (!this.organization.externalSystems) {
				this.organization.externalSystems = [];
			}
			
			// Check for duplicates (case-insensitive)
			const exists = this.organization.externalSystems.some(
				s => s.toLowerCase() === systemName.toLowerCase()
			);
			if (exists) {
				this.notification('warning', 'This external system already exists.');
				return;
			}
			
			// Add to local list
			this.organization.externalSystems.push(systemName);
			this.newExternalSystem = '';
			
			// Save to server
			this.saveExternalSystems();
		},
		
		removeExternalSystem(systemName) {
			if (!this.organization.externalSystems) {
				return;
			}
			
			// Remove from local list
			this.organization.externalSystems = this.organization.externalSystems.filter(
				s => s !== systemName
			);
			
			// Save to server
			this.saveExternalSystems();
		},
		
		saveExternalSystems() {
			this.buttonSaving.saveExternalSystems = true;
			
			orgService.mutation("updateExternalSystems", {
				"external_systems": this.organization.externalSystems || []
			}).then(response => {
				this.buttonSaving.saveExternalSystems = false;
				this.notification('success', 'External systems updated.');
			}).catch(error => {
				console.error("Unable to update external systems:", error);
				this.buttonSaving.saveExternalSystems = false;
				this.notification('error', 'Failed to update external systems.');
			});
		},
		customEmailParamInsert(value){
			this.customEmailBody = this.customEmailBody + value;
		},
		updateEmail(replyToEmail){
			let self = this;
			if(replyToEmail){
				self.buttonSaving.updateReplyTo = true;
				orgService.mutation("updateGuestEmail",{subject:self.customEmailSubject, header: self.customEmailHeading, body: self.customEmailBody, replyToEmail : replyToEmail}).then(result =>{
					self.buttonSaving.updateReplyTo = false;
					try {
						woopra.track("Updated ReplyTo Email",{newReplyTo : replyToEmail});
					} catch (woopraError) {
						console.error("Woopra not loaded.");
					}
				}).catch(err =>{
					console.error("Failed to update Email params: " + err);
					self.emailSaving = false;
				})
			}else{
				this.emailSaving = true;
				orgService.mutation("updateGuestEmail",{subject:self.customEmailSubject, header: self.customEmailHeading, body: self.customEmailBody}).then(result =>{
					self.emailChangedFlag = false;
					self.emailSaving = false;
					try {
						woopra.track("Updated Email Template");
					} catch (woopraError) {
						console.error("Woopra not loaded.");
					}
				}).catch(err =>{
					console.error("Failed to update Email params: " + err);
					self.emailSaving = false;
				})
			}
		},
		removeCompanyLogo() {
			this.buttonSaving.updateLogo = true;
			orgService.mutation("uploadLogo", {
				"filename": "remove.del"
			}).then(response => {
				this.organization.logo_s3_path = null;
				setTimeout(() => {
					EventBus.$emit("refreshlazy", {oldId: this.organization.id, newId: "none"});
					this.buttonSaving.updateLogo = false;
				}, 100);

				this.modals.organizationProfile = false;
			}).catch(error => {
				console.error("Unable to remove logo.");
				this.buttonSaving.updateLogo = false;
			});
		},
		saveCompanyLogo(file) {
			let self = this;
			self.buttonSaving.updateLogo = true;
			if (file && file.target && file.target.files.length > 0 && file.target.files[0]) {
				let uploadTargetFile = file.target.files[0];
				let fileName = uploadTargetFile.name;
				if ((uploadTargetFile.size / 1024) > 1000) {
					self.buttonSaving.updateLogo = false;
					alert("Please select a logo smaller than 1mb.")
				} else {
					toBase64(file.target.files[0]).then(logoFileData => {
						//1. upload org logo to s3
						//2. save s3 id to self.organization.logo_s3_path and company name
						//3. update org in dynamo
						orgService.mutation("uploadLogo", {
							"filename": fileName,
							"data": logoFileData
						}).then(response => {
							try {
								woopra.track("Uploaded Company Logo");
							} catch (woopraError) {
								console.error("Woopra not loaded.");
							}
							self.organization.logo_s3_path = response;
							setTimeout(() => {
								EventBus.$emit("refreshlazy", {oldId: self.organization.logo_s3_path, newId: self.organization.logo_s3_path});
								self.buttonSaving.updateLogo = false;
							}, 500);
						}).catch(error => {
							console.error("Unable to upload logo.");
							self.notification("error", "Unable to load logo. Please make sure the file is a picture format and less than 100kb.");
							self.buttonSaving.updateLogo = false;
						});
					}).catch(fileDataError => {
						console.error("File data error: " + JSON.stringify(fileDataError));
						self.buttonSaving.updateLogo = false;
					});
				}
			} else {
				console.error("No file selected.");
				self.buttonSaving.updateLogo = false;
			}
		},
		getOrg() {
			let self = this;
			return new Promise(resolve => {
				stripeService.query("getOrgById", {org_id: self.user.administratorOf}, "organization", {vuexCache: false}).then(refreshOrg => {
					//console.log("ORG: " + JSON.stringify(this.organization));
					if (!this.organization["termsAndConditions"]) {
						this.organization["termsAndConditions"] = "Responsibility for Data: You have sole responsibility for all Files you upload into this portal through use of the Services. You acknowledge and agree that the Portal Host will not be responsible for any failure of the Services to store a Guest File, for the deletion of a Guest File stored on the Services, or for the corruption of or loss or any data, information, or content contained in a Guest File. You acknowledge sole responsibility for and assume all risk arising from your Portal access.";
					}
					
					// Load MFA requirement setting
					self.requireMfaForVaultAccess = self.organization.requireMfaForVaultAccess || false;

					// Load AI file naming setting (stored as an opt-out flag)
					self.aiFileNamingEnabled = !self.organization.aiFileNamingDisabled;
					
					resolve(refreshOrg);
				});
			});
		},
		editBillingInformation() {
			let self = this;
			stripeService.jumpToEditBillingPage(this.organization.stripeCustomerId).then(error => {
				if (error) {
					self.notification("error", error);
				}
			});
		},
		getStripe(billingEdit) {
			let self = this;
			//console.log(JSON.stringify(self.organization));
			if (!billingEdit) {
				let billingEdit = false;
			}
			return new Promise((resolve, reject) => {
				if (self.organization && self.organization.stripeCustomerId) {
					stripeService.query('getStripe', {
						stripeCustomerId: self.organization.stripeCustomerId,
						stripeEdit: billingEdit
					})
						.then(response => {
							if (response) {
								console.log(`STRIPE : ${response}`);
								response = JSON.parse(response);
								self.stripeStatus = response.stripeStatus;
								self.stripeSubId = response.subId;
								self.stripeNextPayment = response.nextBillingDate;
								self.stripeStartDate = response.startDate;
								self.invoices = response.inv;
								self.stripeInterval = response.payInterval;
								self.stripeBillingAmount = response.amount;
								self.stripeLastFour = response.last4;
								self.stripeTrialEndDate = response.trialEndDate;
							self.stripeCardBrand = response.cardBrand;
							self.stripeCardExpiration = response.cardExpiration;
							
							// Use the actual upcoming invoice amount from Stripe
							if (response.upcomingInvoiceAmount) {
								self.stripeNextInvoiceAmount = response.upcomingInvoiceAmount;
							}
							self.stripeNextInvoiceProration = response.upcomingInvoiceProration ? response.upcomingInvoiceProration : "";
							self.stripeNextInvoiceBase = response.upcomingInvoicePlanAmount ? response.upcomingInvoicePlanAmount : "";

							stripeService.query("getOrgById", {org_id: self.user.administratorOf}, "organization", {vuexCache: false}).then(refreshOrg => {
								self.newOrganizationTier = refreshOrg.tier;
								if (self.$refs.planSelector) {
									self.$refs.planSelector.refresh();
								}

								resolve("success");
							});
							} else {
								reject("Unable to get stripe response.");
							}
						}).catch(error => {
							reject(error);
					});
				}
			})
		},
		cancelStripe(){
			let self = this;
			if(self.organization && self.organization.stripeCustomerId){
				stripeService.mutation("updateStripe",
					{
						orgId : self.organization.id,
						subscriptionId: self.stripeSubId,
						newTier: 'canceled',
						cancelStripe: true,
						calcProration: false,
						stripeCustomerId: self.organization.stripeCustomerId,
						stripeDiscount: false
					}).then(stripeCancelled => {
						stripeService._log("Subscription has been cancelled, refreshing organization.");
						stripeService.mutation("sendFeedback", {
							message: self.cancelComments,
							feedbackType: self.cancelSelection
						}).then(feedbackResult => {
							self.getOrg().then(result => {
								self.progress.cancelStripe = false;
								self.modals.cancelStripe = false;
								self.newOrganizationTier = "cancelled";
								if (self.$refs.planSelector) {
									self.$refs.planSelector.refresh();
								}
							});
						});
				}).catch(err => {
					orgService._debug("Settings - Subscription Cancel Error - " + err);
					self.progress.cancelStripe = false;
					self.modals.cancelStripe = false;
				});
			}
		},
		planProrationMessage({ plan, discount, stripePlanUpdateResponse }) {
			let message = "";
			if (stripePlanUpdateResponse) {
				if (stripePlanUpdateResponse.indexOf("-") > -1) {
					message = `Selecting the ${discount ? "Annual" : "Monthly"} ${plan} Plan will issue a prorated refund of ${stripePlanUpdateResponse} please click 'Update' to confirm this change.`;
				} else {
					message = `Selecting the ${discount ? "Annual" : "Monthly"} ${plan} Plan will incur a prorated charge for the current month on the next invoice : ${stripePlanUpdateResponse} please click 'Update' to confirm this change.`;
				}
			}

			return message;
		},
		saveChangeStripePlan({ plan, discount, stripePlanUpdateResponse }) {
			return new Promise(resolve => {
				this.changeStripePlan(plan, discount);
				this.closePopup("confirmPlanChange");
				resolve(true);
			});
		},
		cancelChangeStripePlan() {
			return new Promise(resolve => {
				this.$refs.planSelector.setDiscount(this.stripeInterval.toLowerCase() !== "month");
				this.$refs.planSelector.refresh();
				this.$refs.planSelector.setInProgress(false);
				this.closePopup("confirmPlanChange");
				resolve(true);
			});
		},
		promptChangeStripePlan({plan, discount, onlyName}) {
			let self = this;
			let currentPlanIsDiscounted = self.stripeInterval.toLowerCase() !== "month";

			// Only treat this as a brand new subscription when the org's tier confirms
			// there is no active plan. If stripeSubId simply failed to load for an active
			// subscriber, sending them to Checkout would create a duplicate subscription.
			let hasActiveTier = self.organization && self.organization.tier && self.organization.tier !== "null" && self.organization.tier !== "canceled";
			if (plan && self.organization && !self.stripeSubId && !hasActiveTier && plan !== "none") {
				//No current subscription
				self.$refs.planSelector.setInProgress(true);
				stripeService.jumpToNewAccountCheckoutPage(
					plan.toLowerCase(),
					discount,
					self.organization.stripeCustomerId).then(response => {
						if (response) {
							self.notification("error", response);
						} else {
							console.log("Redirecting user to stripe checkout page.");
						}
					self.$refs.planSelector.setInProgress(false);
					});
			} else if (plan && self.organization && !self.stripeSubId && plan !== "none") {
				// Active tier but no subscription id loaded - refresh instead of risking a duplicate checkout.
				self.notification("error", "Your subscription details are still loading, please try again in a moment.");
				self.getStripe(false);
			} else if (plan && self.organization && self.organization.stripeCustomerId && (plan.toLowerCase() !== self.organization.tier || discount !== currentPlanIsDiscounted) && plan !== "none") {
				self.$refs.planSelector.setInProgress(true);
				stripeService.mutation("updateStripe",
					{
						orgId : self.organization.id,
						subscriptionId: self.stripeSubId,
						newTier: plan.toLowerCase(), //orgTier
						cancelStripe: false,
						calcProration: true,
						stripeCustomerId: self.organization.stripeCustomerId,
						stripeDiscount: discount //isAnnual
					}).then(stripePlanUpdateResponse => {
					stripeService._log("Subscription proration has been estimated.");

					this.openPopup('confirmPlanChange', { plan, discount, stripePlanUpdateResponse });
				}).catch(err => {
					orgService._debug("Settings - Subscription Plan Proration Error - " + err);
				});
			}
		},
		changeStripePlan(planName, discount) {
			let self = this;
			if(self.organization && self.organization.stripeCustomerId){
				// Save the current tier before changing to detect downgrades
				const oldTier = self.organization.tier;
				const newTier = planName.toLowerCase();
				
				stripeService.mutation("updateStripe",
					{
						orgId : self.organization.id,
						subscriptionId: self.stripeSubId,
						newTier: newTier, //orgTier
						cancelStripe: false,
						calcProration: false,
						stripeCustomerId: self.organization.stripeCustomerId,
						stripeDiscount: discount //isAnnual
					}).then(stripePlanUpdateResponse => {
					stripeService._log("Subscription plan has been updated, refreshing organization.");
					self.getOrg().then(result => {
						self.getStripe(false);
						//done
						self.stripeInterval = discount ? 'year' : 'month';
						
						// Check if downgrade requires resetting tier-specific features
						if (self.requiresFeatureReset(oldTier, newTier)) {
							self.resetTierSpecificFeatures(oldTier, newTier).then(() => {
								stripeService._log("Tier-specific features reset successfully after downgrade.");
							}).catch(error => {
								console.error("Error resetting tier-specific features:", error);
							});
						}
						
						vaultService.mutation("updateVaultForTier",{}).then(response =>{
							for (let i = 0; i < self.vaults.length; i++) {
								if (self.vaults[i].org_id === self.organization.id) {
									self.vaults[i].orgTier = self.organization.tier;
								}
							}
						}).catch(e =>{
							vaultService._log("Updating vaults to new tier failed : " + JSON.stringify(e));
						});

						self.$refs.planSelector.setInProgress(false);
					});
				}).catch(err => {
					orgService._debug("Settings - Subscription Plan Update Error - " + err);
					self.$refs.planSelector.setInProgress(false);
				});
			}
		},
		updateMemberPermissions(email, valueToChange) {
			let self = this;
			orgService.mutation("updatePerms", {memberEmail: email, valueToChange: valueToChange}).then(result => {
				self.getOrg().then(refreshOrg => {
				});
			});
			try {
				woopra.track("Change Member Permission", {Company : self.organizationId.companyName, PermissionChanged: valueToChange});
			} catch (woopraError) {
				console.error("Woopra not loaded.");
			}
		},
		startMemberNameEdit(item) {
			// Use Vue.set to ensure reactivity for new properties
			this.$set(item, '_editingName', true);
			this.$set(item, '_editNameValue', item.user_name);
		},
		saveMemberNameEdit(item) {
			let self = this;
			if (!item._editNameValue || item._editNameValue.trim() === '') {
				self.notification('error', "Member name cannot be empty.");
				// Reset to original name and exit edit mode
				item._editNameValue = item.user_name;
				item._editingName = false;
				return;
			}

			console.log('Saving member name edit:', {
				email: item.email,
				valueToChange: 'user_name',
				newValue: item._editNameValue.trim(),
				originalName: item.user_name
			});

			orgService.mutation("updatePerms", {
				memberEmail: item.email,
				valueToChange: 'user_name',
				newValue: item._editNameValue.trim()
			}).then(response => {
				console.log('updatePerms response:', response);
				// Refresh organization data from server to get the updated name
				self.getOrg().then(refreshOrg => {
					// Refresh the members list to get updated permissions/names
					orgService.query("getMembersForOrgId", {org_id: self.organization.id}, "members", {vuexCache: false}).then(members => {
						self.perms = [];
						if (members && self.organization.permissions) {
							for (let x = 0; members.length > x; x++) {
								if(members[x]._deleted !== 1){
									for (let p = 0; self.organization.permissions.length > p; p++) {
										if (members[x].email === self.organization.permissions[p].user_email && self.organization.permissions[p]._deleted !== 1) {
											self.perms.push({
												...members[x],
												...self.organization.permissions[p]
											});
											break;
										}
									}
								}
							}
						}
					});
				});
				item._editingName = false;
				self.notification('success', "Member name updated successfully.");
			}).catch(error => {
				console.error('updatePerms error:', error);
				self.notification('error', "Unable to update member name.");
				// Reset to original name
				item._editNameValue = item.user_name;
				item._editingName = false;
			});
		},
		cancelMemberNameEdit(item) {
			item._editNameValue = item.user_name;
			item._editingName = false;
		},
		init(addedMember) {
			let self = this;
			let billingEdit = false;
			if (this.$route.query.updated === 'true') {
				billingEdit = true;
			}

			this.redirectReason = this.$route.query.reason;

			if (self.organization && self.organization.id) {
				if (self.organization.tier !== 'null') {
					console.log("Organization loaded with tier: " + self.organization.tier);
					self.newOrganizationTier = self.organization.tier;
				}
				let refreshOrgId = (self.user && (self.user.memberOf || self.user.administratorOf)) || self.organization.id;
				orgService.query("getOrgById", {org_id: refreshOrgId}, "organization", {vuexCache: false}).then(refreshOrg => { //To refresh after adding a new member.
					if (self.organization.body) {
						self.customEmailBody = self.organization.body;
						self.customEmailHeading = self.organization.header;
						self.customEmailSubject = self.organization.subject;
					}

					if (self.organization.replyToEmail) {
						self.replyToEmail = self.organization.replyToEmail;
					}

					// Initialize workflow states
					if (self.organization.workflowStatesEnabled !== undefined) {
						self.workflowStatesEnabled = self.organization.workflowStatesEnabled;
					}
					if (self.organization.workflowStates && self.organization.workflowStates.length > 0) {
						self.workflowStates = [...self.organization.workflowStates];
					}

					// Initialize branding settings
					if (self.organization.hideZapaLogo !== undefined) {
						self.hideZapaLogo = self.organization.hideZapaLogo;
					}
					if (self.organization.primaryBrandColor) {
						self.primaryBrandColor = self.organization.primaryBrandColor;
						self.applyBrandColor();
					}
					if (self.organization.primaryBrandColorName) {
						self.primaryBrandColorName = self.organization.primaryBrandColorName;
					}

					orgService.query("getMembersForOrgId", {org_id: self.organization.id}, "members", {vuexCache: false}).then(members => {
						self.perms = [];
						if (members && self.organization.permissions) {
							for (let x = 0; members.length > x; x++) {
								if(members[x]._deleted !== 1){
									for (let p = 0; self.organization.permissions.length > p; p++) {
										if (members[x].email === self.organization.permissions[p].user_email && self.organization.permissions[p]._deleted !== 1) {
											self.perms.push({
												...members[x],
												...self.organization.permissions[p]
											});
											break;
										}
									}
								}
							}
						}

						self.loading = false;
					}).catch(err => {
						orgService._debug("Settings - getMembersForOrgId Error - " + err);
						self.loading = false;
					});
				});

				if (self.isCurrentUserAdmin) {
					if (self.organization && self.organization.stripeCustomerId) {
						let tempOrgPlan = self.organization.tier;
						self.getStripe(billingEdit).then(result => {
							self.getOrg().then(result => {
								if(tempOrgPlan !== self.organization.tier){
									vaultService.mutation("updateVaultForTier",{}).then(response =>{
										for (let i = 0; i < self.vaults.length; i++) {
											if (self.vaults[i].org_id === self.organization.id) {
												self.vaults[i].orgTier = self.organization.tier;
											}
										}
									}).catch(e =>{
										vaultService._log("Updating vaults to new tier failed : " + JSON.stringify(e));
									});
								}
								stripeService._log("Returning from Stripe Edit, refreshing organization.");
							});
						}).catch(err => {
							self.getOrg().then(result => {
								stripeService._log("Returning from Stripe Edit, refreshing organization.");
							});
						});
					} else {
						//TODO: No stripe ID. Redirect to /new or jump to checkout?
						console.error("UNKNOWN ERROR, NO STRIPE CUSTOMER ID.");
				}
			} else {
				console.error("UNABLE TO FIND ORG ID."); //SOMEDAY: Redirect to createNewAccount flow?
			}
		}
		},
		addMember() {
			let self = this;
			self.progress.addMember = true;
			if(self.newMemberEmail && self.newMemberName){
				orgService.mutation("inviteNewMember", {
					org_id: self.organization.id,
					email: self.newMemberEmail.toLowerCase().trim(),
					name: self.newMemberName.trim()
				}).then(response => {
					try {
						woopra.track("Create New Member", {MemberEmail: self.newMemberEmail, Company : self.organizationId.companyName});
					} catch (woopraError) {
						console.error("Woopra not loaded.");
					}
					//console.log("Member created.");
					self.modals.addMember = false;
					self.progress.addMember = false;
					self.newMemberEmail = '';
					self.newMemberName = '';
					self.loading = true;
					setTimeout(() => {
						self.init(true);
					}, 500);
				}).catch(e =>{
					self.addMemberError = e.graphQLErrors[0].message;
					self.addMemberError = self.addMemberError.replace("undefined - ", "");
					self.addMemberAlert = true;
				});
			}else{
				self.notification("error","Both Name and Email are required, please try again.");
				self.progress.addMember = false;
			}
		},
		disableMember() {
			let self = this;
			orgService.mutation("disableMember", {memberId: self.memberToDelete}).then(response => {
				if (response) {
					orgService.query("getMembersForOrgId", {org_id: self.organization.id}, "members", {vuexCache: false}).then(members => {
						self.perms = [];
						if (members && self.organization.permissions) {
							for (let x = 0; members.length > x; x++) {
								if (members[x]._deleted !== 1) {
									for (let p = 0; self.organization.permissions.length > p; p++) {
										if (members[x].email === self.organization.permissions[p].user_email && self.organization.permissions[p]._deleted !== 1) {
											self.perms.push({
												...members[x],
												...self.organization.permissions[p]
											});
											break;
										}
									}
								}
							}
						}
						self.loading = false;
					});
					self.progress.memberDelete = false;
					self.modals.memberDelete = false;
					self.memberToDelete = "";

				} else {
					self.progress.memberDelete = false;
					self.modals.memberDelete = false;
					self.memberToDelete = "";
				}
			})
		},
		createPortalTemplate() {
			this.templateName = "";
			this.modals.createTemplate = true;
		},
		savePortalTemplate() {
			let self = this;
			if (!self.templateName || self.templateName.trim() === '') {
				self.notification('error', "Template name is required.");
				return;
			}

			self.progress.createTemplate = true;
			
			// Create a portal with template property
			vaultService.mutation("createVault", {
				name: self.templateName.trim(),
				org_id: self.organization.id,
				tags: [],
				isTemplate: true
			}).then(response => {
				self.progress.createTemplate = false;
				self.modals.createTemplate = false;
				self.templateName = "";
				if (response && response.id) {
					self.notification("success", "Portal template created successfully!");
					// Refresh templates list
					self.loadTemplates();
					try {
						woopra.track("Created Portal Template", {
							Company: self.organization.companyName,
							TemplateId: response.id,
							TemplateName: self.templateName.trim()
						});
					} catch (woopraError) {
						console.error("Woopra not loaded.");
					}
				}
			}).catch(error => {
				self.progress.createTemplate = false;
				console.error("Failed to create portal template:", error);
				self.notification("error", "Failed to create portal template. Please try again.");
			});
		},
		loadTemplates() {
			let self = this;
			vaultService.query("getVaultsByOrgId", { templatesOnly: true }).then(templates => {
				self.templates = templates || [];
			}).catch(error => {
				console.error("Failed to load templates:", error);
				self.templates = [];
			});
		},
		confirmDeleteTemplate(template) {
			this.templateToDelete = template;
			this.modals.deleteTemplate = true;
		},
		deleteTemplate() {
			let self = this;
			if (!self.templateToDelete) return;

			self.progress.deleteTemplate = true;

			vaultService.mutation("deleteVault", {
				vault_id: self.templateToDelete.id
			}).then(response => {
				self.progress.deleteTemplate = false;
				self.modals.deleteTemplate = false;
				self.notification("success", `Template "${self.templateToDelete.name}" has been deleted successfully.`);
				self.templateToDelete = null;
				// Refresh templates list
				self.loadTemplates();
				try {
					woopra.track("Deleted Portal Template", {
						Company: self.organization.companyName,
						TemplateId: self.templateToDelete.id,
						TemplateName: self.templateToDelete.name
					});
				} catch (woopraError) {
					console.error("Woopra not loaded.");
				}
			}).catch(error => {
				self.progress.deleteTemplate = false;
				console.error("Failed to delete template:", error);
				self.notification("error", "Failed to delete template. Please try again.");
			});
		},
		toggleArchiveTemplate(template) {
			this.templateToArchive = template;
			this.modals.archiveTemplate = true;
		},
		archiveTemplate() {
			let self = this;
			if (!self.templateToArchive) return;

			self.progress.archiveTemplate = true;
			const newArchivedState = !self.templateToArchive.archived;

			vaultService.mutation("updateVaultSettings", {
				org_id: self.organization.id,
				vault_id: self.templateToArchive.id,
				archived: newArchivedState,
				private_mode: Boolean(self.templateToArchive.private_mode) || false,
				hide_perms: Boolean(self.templateToArchive.hide_perms) || false,
				isTemplate: Boolean(self.templateToArchive.isTemplate) || false
			}).then(response => {
				self.progress.archiveTemplate = false;
				self.modals.archiveTemplate = false;
				const action = newArchivedState ? "archived" : "unarchived";
				self.notification("success", `Template "${self.templateToArchive.name}" has been ${action} successfully.`);
				self.templateToArchive = null;
				// Refresh templates list
				self.loadTemplates();
				try {
					woopra.track(`${newArchivedState ? 'Archived' : 'Unarchived'} Portal Template`, {
						Company: self.organization.companyName,
						TemplateId: self.templateToArchive.id,
						TemplateName: self.templateToArchive.name
					});
				} catch (woopraError) {
					console.error("Woopra not loaded.");
				}
			}).catch(error => {
				self.progress.archiveTemplate = false;
				console.error("Failed to archive/unarchive template:", error);
				self.notification("error", `Failed to ${newArchivedState ? 'archive' : 'unarchive'} template. Please try again.`);
			});
		},
		navigateToTemplate(template) {
			this.$router.push(`/org/${template.org_id}/vault/${template.id}/folder/main`);
		},
		openCreatePortalFromTemplate(template) {
			this.selectedTemplateForPortal = template;
			this.newPortalFromTemplate = {
				name: '',
				tagsRaw: ''
			};
			this.modals.createPortalFromTemplate = true;
		},
		closeCreatePortalFromTemplate() {
			this.modals.createPortalFromTemplate = false;
			this.selectedTemplateForPortal = null;
			this.newPortalFromTemplate = {
				name: '',
				tagsRaw: ''
			};
			this.progress.createPortalFromTemplate = false;
		},
		createPortalFromTemplate() {
			let self = this;
			if (!self.newPortalFromTemplate.name || self.newPortalFromTemplate.name.trim() === '') {
				self.notification('error', "Portal name is required.");
				return;
			}
			
			if (!self.selectedTemplateForPortal) {
				self.notification('error', "No template selected.");
				return;
			}

			self.progress.createPortalFromTemplate = true;
			
			// Parse tags from comma-separated string
			let tags = (self.newPortalFromTemplate.tagsRaw || '').split(',').map(t => t.trim()).filter(Boolean);
			
			// Create a portal using the template
			vaultService.mutation("createVault", {
				name: self.newPortalFromTemplate.name.trim(),
				org_id: self.organization.id,
				tags: tags,
				templateId: self.selectedTemplateForPortal.id
			}).then(response => {
				self.progress.createPortalFromTemplate = false;
				self.modals.createPortalFromTemplate = false;
				
				if (response && response.id) {
					self.notification("success", `Portal "${self.newPortalFromTemplate.name.trim()}" created successfully from template!`);
					
					try {
						woopra.track("Created Portal from Template", {
							Company: self.organization.companyName,
							TemplateId: self.selectedTemplateForPortal.id,
							TemplateName: self.selectedTemplateForPortal.name,
							PortalId: response.id,
							PortalName: self.newPortalFromTemplate.name.trim()
						});
					} catch (woopraError) {
						console.error("Woopra not loaded.");
					}
					
					// Reset the form
					self.selectedTemplateForPortal = null;
					self.newPortalFromTemplate = {
						name: '',
						tagsRaw: ''
					};
					
					// Navigate to the new portal
					self.$router.push(`/org/${response.org_id}/vault/${response.id}/folder/main`);
				}
			}).catch(error => {
				self.progress.createPortalFromTemplate = false;
				console.error("Failed to create portal from template:", error);
				self.notification("error", "Failed to create portal from template. Please try again.");
			});
		},
		
		navigateToSubscription() {
			this.tabs = this.subscriptionTabIndex;
			// Scroll to top of page for better UX
			this.$nextTick(() => {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			});
		},
		
		// Workflow States Methods
		onWorkflowStatesEnabledChange() {
			if (!this.workflowStatesEnabled) {
				// Reset to default states when disabling
				this.workflowStates = [
					{ id: 1, name: "Intake" },
					{ id: 2, name: "In Progress" },
					{ id: 3, name: "Under Review" },
					{ id: 4, name: "Complete" }
				];
			}
		},
		
		addWorkflowState() {
			const nextId = this.workflowStates.length > 0 ? Math.max(...this.workflowStates.map(s => s.id)) + 1 : 1;
			this.workflowStates.push({
				id: nextId,
				name: `State ${nextId}`
			});
		},
		
		removeWorkflowState(index) {
			if (this.workflowStates.length > 1) {
				const stateToDelete = this.workflowStates[index];
				
				// Check if this state is in use by any vaults
				this.checkWorkflowStateInUse(stateToDelete.id).then(vaultsUsingState => {
					if (vaultsUsingState.length > 0) {
						// Show warning dialog
						this.showWorkflowStateDeleteWarning(stateToDelete, vaultsUsingState, index);
					} else {
						// Safe to delete
						this.confirmRemoveWorkflowState(index);
					}
				});
			}
		},

		confirmRemoveWorkflowState(index) {
			this.workflowStates.splice(index, 1);
			// Reassign IDs to maintain sequence
			this.workflowStates.forEach((state, idx) => {
				state.id = idx + 1;
			});
		},

		checkWorkflowStateInUse(stateId) {
			// Check if any vaults are using this workflow state ID
			return vaultService.query("getVaultsByOrgId", {}).then(vaults => {
				if (!vaults) return [];
				return vaults.filter(vault => vault.workflowStateId === stateId && !vault._deleted);
			}).catch(error => {
				console.error("Error checking workflow state usage:", error);
				return [];
			});
		},

		showWorkflowStateDeleteWarning(state, vaultsUsingState, index) {
			this.workflowStateToDelete = { state, index };
			this.vaultsUsingWorkflowState = vaultsUsingState;
			this.modals.deleteWorkflowStateWarning = true;
		},

		proceedWithWorkflowStateDelete() {
			if (this.workflowStateToDelete) {
				this.confirmRemoveWorkflowState(this.workflowStateToDelete.index);
				this.modals.deleteWorkflowStateWarning = false;
				this.workflowStateToDelete = null;
				this.vaultsUsingWorkflowState = [];
			}
		},
		
		updateWorkflowStatesSettings() {
			this.buttonSaving.updateWorkflowStates = true;
			
			const workflowStatesData = this.workflowStatesEnabled ? JSON.stringify(this.workflowStates) : null;
			
			orgService.mutation("updateWorkflowStates", {
				workflowStatesEnabled: this.workflowStatesEnabled,
				workflowStates: workflowStatesData
			}).then(response => {
				this.buttonSaving.updateWorkflowStates = false;
				// Refresh organization data
				this.init();
			}).catch(error => {
				this.buttonSaving.updateWorkflowStates = false;
				console.error("Error updating workflow states:", error);
			});
		},
		
		// ===== Multi-Workflow System Methods =====
		loadWorkflows() {
			if (!this.organizationId) {
				console.log('[loadWorkflows] No organizationId, skipping');
				return;
			}
			
			console.log('[loadWorkflows] Loading workflows for org:', this.organizationId);
			console.log('[loadWorkflows] About to call orgService.query with getWorkflowsByOrgId');
			
			orgService.query("getWorkflowsByOrgId", {
				org_id: this.organizationId
			}).then(workflows => {
				console.log('[loadWorkflows] Received workflows:', workflows);
				
				// Filter out the legacy/default workflow to prevent duplication/issues
				// The legacy workflow is managed separately via the toggle/legacy settings
				const filteredWorkflows = (workflows || []).filter(w => w.id !== 'legacy');
				
				this.workflows = filteredWorkflows;
				console.log('[loadWorkflows] Set this.workflows to:', this.workflows);
			}).catch(error => {
				console.error("[loadWorkflows] Error loading workflows:", error);
				console.error("[loadWorkflows] Error type:", typeof error);
				console.error("[loadWorkflows] Error details:", JSON.stringify(error, null, 2));
				if (error.graphQLErrors) {
					console.error("[loadWorkflows] GraphQL Errors:", error.graphQLErrors);
				}
				if (error.networkError) {
					console.error("[loadWorkflows] Network Error:", error.networkError);
				}
				this.workflows = [];
			});
		},
		
		openCreateWorkflowDialog() {
			this.selectedWorkflow = null;
			this.editingWorkflow = {
				name: '',
				description: '',
				states: [
					{ id: 0, name: "Intake" },
					{ id: 1, name: "In Progress" },
					{ id: 2, name: "Under Review" },
					{ id: 3, name: "Complete" }
				]
			};
			this.modals.workflowDialog = true;
		},
		
		openEditWorkflowDialog(workflow) {
			// Handle legacy workflow editing
			if (workflow.isLegacy) {
				// For legacy workflow, we use the same dialog but save using updateWorkflowStatesSettings
				this.selectedWorkflow = null; // Not editing a new-style workflow
				this.editingLegacyWorkflow = true; // Flag for saving logic
				this.editingWorkflow = {
					name: workflow.name,
					description: workflow.description || '',
					states: JSON.parse(JSON.stringify(workflow.states)) // Deep clone
				};
				this.modals.workflowDialog = true;
				return;
			}
			
			// Edit new-style workflow
			this.selectedWorkflow = workflow;
			this.editingLegacyWorkflow = false;
			this.editingWorkflow = {
				name: workflow.name,
				description: workflow.description || '',
				states: JSON.parse(JSON.stringify(workflow.states)) // Deep copy
			};
			this.modals.workflowDialog = true;
		},
		
		closeWorkflowDialog() {
			this.modals.workflowDialog = false;
			this.selectedWorkflow = null;
			this.editingWorkflow = {
				name: '',
				description: '',
				states: []
			};
		},
		
		addWorkflowStateInDialog() {
			const nextId = this.editingWorkflow.states.length > 0 
				? Math.max(...this.editingWorkflow.states.map(s => s.id)) + 1 
				: 0;
			this.editingWorkflow.states.push({
				id: nextId,
				name: `State ${nextId + 1}`
			});
		},
		
		removeWorkflowStateInDialog(index) {
			if (this.editingWorkflow.states.length > 1) {
				this.editingWorkflow.states.splice(index, 1);
				// Reassign IDs to maintain sequence
				this.editingWorkflow.states.forEach((state, idx) => {
					state.id = idx;
				});
			} else {
				this.notification('error', 'Workflow must have at least one state');
			}
		},
		
		saveWorkflow() {
			// Validate
			if (!this.editingWorkflow.name || this.editingWorkflow.name.trim() === '') {
				this.notification('error', 'Workflow name is required');
				return;
			}
			
			if (this.editingWorkflow.states.length === 0) {
				this.notification('error', 'Workflow must have at least one state');
				return;
			}
			
			// Check for empty state names
			for (const state of this.editingWorkflow.states) {
				if (!state.name || state.name.trim() === '') {
					this.notification('error', 'All states must have a name');
					return;
				}
			}
			
			this.buttonSaving.saveWorkflow = true;
			
			const statesJson = JSON.stringify(this.editingWorkflow.states);
			
			if (this.editingLegacyWorkflow) {
				// Update legacy organization-level workflow states
				this.workflowStates = JSON.parse(JSON.stringify(this.editingWorkflow.states)); // Update the org-level states
				orgService.mutation("updateWorkflowStates", {
					workflowStatesEnabled: this.workflowStatesEnabled,
					workflowStates: statesJson
				}).then(response => {
					this.buttonSaving.saveWorkflow = false;
					this.notification('success', 'Legacy workflow updated successfully');
					this.closeWorkflowDialog();
					// Reload organization to get updated workflowStates
					return stripeService.query("getOrgById", {
						org_id: this.organizationId
					}, "organization", { vuexCache: false });
				}).catch(error => {
					this.buttonSaving.saveWorkflow = false;
					console.error("Error updating legacy workflow:", error);
					this.notification('error', error.message || 'Failed to update legacy workflow');
				});
			} else if (this.selectedWorkflow) {
				// Update existing workflow
				orgService.mutation("updateWorkflow", {
					id: this.selectedWorkflow.id,
					name: this.editingWorkflow.name.trim(),
					description: this.editingWorkflow.description ? this.editingWorkflow.description.trim() : null,
					states: statesJson
				}).then(response => {
					this.buttonSaving.saveWorkflow = false;
					this.notification('success', 'Workflow updated successfully');
					this.closeWorkflowDialog();
					this.loadWorkflows();
				}).catch(error => {
					this.buttonSaving.saveWorkflow = false;
					console.error("Error updating workflow:", error);
					this.notification('error', error.message || 'Failed to update workflow');
				});
			} else {
				// Create new workflow
				orgService.mutation("createWorkflow", {
					name: this.editingWorkflow.name.trim(),
					description: this.editingWorkflow.description ? this.editingWorkflow.description.trim() : null,
					states: statesJson
				}).then(response => {
					this.buttonSaving.saveWorkflow = false;
					this.notification('success', 'Workflow created successfully');
					this.closeWorkflowDialog();
					this.loadWorkflows();
				}).catch(error => {
					this.buttonSaving.saveWorkflow = false;
					console.error("Error creating workflow:", error);
					const errorMsg = error.message || error.toString();
					if (errorMsg.includes('10 workflows')) {
						this.notification('error', 'Maximum of 10 workflows per organization reached');
					} else {
						this.notification('error', errorMsg || 'Failed to create workflow');
					}
				});
			}
		},
		
		confirmDeleteWorkflow(workflow) {
			// Cannot delete legacy workflow - must disable it in settings
			if (workflow.isLegacy) {
				this.notification('error', 'Cannot delete the default workflow. Use the toggle above to disable legacy workflow mode.');
				return;
			}
			
			this.workflowToDelete = workflow;
			this.checkWorkflowInUse(workflow.id);
		},
		
		checkWorkflowInUse(workflowId) {
			vaultService.query("getVaultsByOrgId", {}).then(vaults => {
				if (!vaults) {
					this.vaultsUsingWorkflow = [];
					this.modals.deleteWorkflowDialog = true;
					return;
				}
				
				const vaultsUsing = vaults.filter(vault => 
					vault.workflowId === workflowId && !vault._deleted
				);
				
				this.vaultsUsingWorkflow = vaultsUsing;
				this.modals.deleteWorkflowDialog = true;
			}).catch(error => {
				console.error("Error checking workflow usage:", error);
				this.vaultsUsingWorkflow = [];
				this.modals.deleteWorkflowDialog = true;
			});
		},
		
		proceedWithWorkflowDelete() {
			if (!this.workflowToDelete) return;
			
			if (this.vaultsUsingWorkflow.length > 0) {
				this.notification('error', `Cannot delete workflow. It is being used by ${this.vaultsUsingWorkflow.length} portal(s).`);
				this.modals.deleteWorkflowDialog = false;
				return;
			}
			
			orgService.mutation("deleteWorkflow", {
				id: this.workflowToDelete.id
			}).then(response => {
				this.notification('success', 'Workflow deleted successfully');
				this.modals.deleteWorkflowDialog = false;
				this.workflowToDelete = null;
				this.vaultsUsingWorkflow = [];
				this.loadWorkflows();
			}).catch(error => {
				console.error("Error deleting workflow:", error);
				const errorMsg = error.message || error.toString();
				this.notification('error', errorMsg || 'Failed to delete workflow');
				this.modals.deleteWorkflowDialog = false;
			});
		},
		
		cancelWorkflowDelete() {
			this.modals.deleteWorkflowDialog = false;
			this.workflowToDelete = null;
			this.vaultsUsingWorkflow = [];
		},
		
		getWorkflowUsageCount(workflowId) {
			// This will be computed in real-time from vaults data if needed
			// For now, return a placeholder
			return 0;
		},
		saveRequireMfaSetting() {
			let self = this;
			self.buttonSaving.updateMfaRequirement = true;
			
			orgService.mutation("updateOrganizationBoolean", {
				field: "requireMfaForVaultAccess",
				value: self.requireMfaForVaultAccess
			}).then(response => {
				console.log("saveRequireMfaSetting response: " + JSON.stringify(response));
				self.buttonSaving.updateMfaRequirement = false;
				
				if (self.requireMfaForVaultAccess) {
					self.notification('success', 'MFA requirement enabled. All users will need to set up MFA within 7 days.');
				} else {
					self.notification('success', 'MFA requirement disabled. Users can optionally keep MFA enabled.');
				}
				
				// Reload organization data
				self.getOrg();
			}).catch(error => {
				console.error("Error updating MFA requirement:", error);
				self.buttonSaving.updateMfaRequirement = false;
				self.notification('error', 'Failed to update MFA requirement');
			});
		},
		saveAiFileNamingSetting() {
			let self = this;
			self.buttonSaving.updateAiFileNaming = true;

			orgService.mutation("updateOrganizationBoolean", {
				field: "aiFileNamingDisabled",
				value: !self.aiFileNamingEnabled
			}).then(response => {
				self.buttonSaving.updateAiFileNaming = false;

				if (self.aiFileNamingEnabled) {
					self.notification('success', 'AI file naming enabled. Generic camera photos will get descriptive names automatically.');
				} else {
					self.notification('success', 'AI file naming disabled. Uploaded photos will keep their original filenames.');
				}

				// Reload organization data
				self.getOrg();
			}).catch(error => {
				console.error("Error updating AI file naming setting:", error);
				self.buttonSaving.updateAiFileNaming = false;
				self.notification('error', 'Failed to update AI file naming setting');
			});
		},
		
		updateBrandingSettings() {
			this.buttonSaving.updateBranding = true;
			
			orgService.mutation("updateBrandingSettings", {
				hideZapaLogo: this.hideZapaLogo,
				primaryBrandColor: this.primaryBrandColor,
				primaryBrandColorName: this.primaryBrandColorName
			}).then(response => {
				this.buttonSaving.updateBranding = false;
				this.notification('success', 'Branding settings updated successfully.');
				// Refresh organization data
				this.getOrg().then(() => {
					// Apply new color theme
					this.applyBrandColor();
				});
			}).catch(error => {
				this.buttonSaving.updateBranding = false;
				console.error("Error updating branding settings:", error);
				this.notification('error', 'Failed to update branding settings.');
			});
		},
		
		selectBrandColor(colorOption) {
			this.primaryBrandColor = colorOption.hex;
			this.primaryBrandColorName = colorOption.name;
		},
		
		selectCustomBrandColor(color) {
			// v-color-picker emits either a hex string or an object depending on mode.
			let hex = color;
			if (color && typeof color === 'object') {
				hex = color.hex ? color.hex : (color.hexa ? color.hexa : '');
			}
			if (!hex) {
				return;
			}
			// Drop any alpha channel (#RRGGBBAA -> #RRGGBB) and normalize.
			if (hex.length === 9) {
				hex = hex.substring(0, 7);
			}
			hex = hex.toUpperCase();
			this.primaryBrandColor = hex;
			// Reuse a known swatch name when the custom color matches one, else label it Custom.
			const match = this.brandColorOptions.find(option => option.hex.toUpperCase() === hex);
			this.primaryBrandColorName = match ? match.name : 'Custom';
		},
		
		// Tier comparison and feature reset methods
		getTierLevel(tier) {
			// Returns a numeric value representing the tier level for comparison
			const tierLevels = {
				'starter': 1,
				'professional': 2,
				'large firm': 3,
				'advanced': 3, // Treat advanced as equivalent to large firm
				'enterprise': 4,
				'canceled': 0,
				'null': 0
			};
			return tierLevels[tier] || 0;
		},
		
		requiresFeatureReset(oldTier, newTier) {
			// Check if we're downgrading from a tier with advanced features (large firm/enterprise)
			// to a tier without them (professional/starter)
			const oldLevel = this.getTierLevel(oldTier);
			const newLevel = this.getTierLevel(newTier);
			
			// If old tier had large firm or enterprise features (level 3+) and new tier doesn't
			return oldLevel >= 3 && newLevel < 3;
		},
		
		resetTierSpecificFeatures(oldTier, newTier) {
			const self = this;
			const resetPromises = [];
			
			stripeService._log("Resetting tier-specific features due to downgrade from " + oldTier + " to " + newTier);
			
			// Reset branding settings to defaults
			const brandingPromise = orgService.mutation("updateBrandingSettings", {
				hideZapaLogo: false,
				primaryBrandColor: '#0d7542',
				primaryBrandColorName: 'Emerald'
			}).then(response => {
				stripeService._log("Branding settings reset to defaults.");
				// Update local state
				self.hideZapaLogo = false;
				self.primaryBrandColor = '#0d7542';
				self.primaryBrandColorName = 'Emerald';
				// Apply default color theme
				self.applyBrandColor();
				return response;
			}).catch(error => {
				console.error("Error resetting branding settings:", error);
				throw error;
			});
			
			resetPromises.push(brandingPromise);
			
			// Reset workflow states to defaults
			const defaultWorkflowStates = [
				{ id: 1, name: "Intake" },
				{ id: 2, name: "In Progress" },
				{ id: 3, name: "Under Review" },
				{ id: 4, name: "Complete" }
			];
			
			const workflowPromise = orgService.mutation("updateWorkflowStates", {
				workflowStatesEnabled: false,
				workflowStates: null
			}).then(response => {
				stripeService._log("Workflow states disabled and reset to defaults.");
				// Update local state
				self.workflowStatesEnabled = false;
				self.workflowStates = defaultWorkflowStates;
				return response;
			}).catch(error => {
				console.error("Error resetting workflow states:", error);
				throw error;
			});
			
			resetPromises.push(workflowPromise);
			
			// Return a promise that resolves when all resets are complete
			return Promise.all(resetPromises).then(results => {
				// Refresh organization data to ensure everything is in sync
				return self.getOrg().then(() => {
					stripeService._log("All tier-specific features have been reset successfully.");
					self.notification('info', 'Advanced features have been reset due to subscription downgrade.');
					return results;
				});
			}).catch(error => {
				console.error("Error in resetTierSpecificFeatures:", error);
				throw error;
			});
		},
		
		// Color manipulation helper functions
		hexToRgb(hex) {
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result ? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16)
			} : null;
		},
		
		rgbToHsl(r, g, b) {
			r = r / 255;
			g = g / 255;
			b = b / 255;
			
			const max = Math.max(r, g, b);
			const min = Math.min(r, g, b);
			let h, s, l = (max + min) / 2;
			
			if (max === min) {
				h = s = 0;
			} else {
				const d = max - min;
				s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
				
				switch (max) {
					case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
					case g: h = ((b - r) / d + 2) / 6; break;
					case b: h = ((r - g) / d + 4) / 6; break;
				}
			}
			
			return { h: h * 360, s: s * 100, l: l * 100 };
		},
		
		hslToRgb(h, s, l) {
			h = h / 360;
			s = s / 100;
			l = l / 100;
			
			let r, g, b;
			
			if (s === 0) {
				r = g = b = l;
			} else {
				const hue2rgb = (p, q, t) => {
					if (t < 0) t += 1;
					if (t > 1) t -= 1;
					if (t < 1/6) return p + (q - p) * 6 * t;
					if (t < 1/2) return q;
					if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
					return p;
				};
				
				const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
				const p = 2 * l - q;
				
				r = hue2rgb(p, q, h + 1/3);
				g = hue2rgb(p, q, h);
				b = hue2rgb(p, q, h - 1/3);
			}
			
			return {
				r: Math.round(r * 255),
				g: Math.round(g * 255),
				b: Math.round(b * 255)
			};
		},
		
		rgbToHex(r, g, b) {
			return '#' + [r, g, b].map(x => {
				const hex = x.toString(16);
				return hex.length === 1 ? '0' + hex : hex;
			}).join('');
		},
		
		adjustColorLightness(hex, lightnessAdjustment) {
			const rgb = this.hexToRgb(hex);
			if (!rgb) return hex;
			
			const hsl = this.rgbToHsl(rgb.r, rgb.g, rgb.b);
			hsl.l = Math.max(0, Math.min(100, hsl.l + lightnessAdjustment));
			
			const adjustedRgb = this.hslToRgb(hsl.h, hsl.s, hsl.l);
			return this.rgbToHex(adjustedRgb.r, adjustedRgb.g, adjustedRgb.b);
		},
		
		getContrastTextColor(hex) {
			// Returns '#FFFFFF' or '#000000' depending on which gives a more
			// readable contrast against the supplied background color (WCAG).
			const rgb = this.hexToRgb(hex);
			if (!rgb) return '#FFFFFF';

			const toLinear = channel => {
				const c = channel / 255;
				return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
			};
			const luminance = 0.2126 * toLinear(rgb.r) + 0.7152 * toLinear(rgb.g) + 0.0722 * toLinear(rgb.b);

			const contrastWithWhite = 1.05 / (luminance + 0.05);
			const contrastWithBlack = (luminance + 0.05) / 0.05;
			return contrastWithWhite >= contrastWithBlack ? '#FFFFFF' : '#000000';
		},
		
		applyBrandColor() {
			if (this.primaryBrandColor) {
				// Set base color
				document.documentElement.style.setProperty('--brand-primary-color', this.primaryBrandColor);
				
				// Calculate and set darker variant (20% darker)
				const darkerColor = this.adjustColorLightness(this.primaryBrandColor, -20);
				document.documentElement.style.setProperty('--brand-primary-dark', darkerColor);
				
		// Calculate and set light variant (15% lighter - keeps contrast for white text)
		const lightColor = this.adjustColorLightness(this.primaryBrandColor, 15);
		document.documentElement.style.setProperty('--brand-primary-light', lightColor);
				
				// Calculate and set lighter variant (70% lighter for subtle backgrounds)
				const lighterColor = this.adjustColorLightness(this.primaryBrandColor, 70);
				document.documentElement.style.setProperty('--brand-primary-lighter', lighterColor);
				
				// Choose readable font color (white or black) for text on the brand color
				const textColor = this.getContrastTextColor(this.primaryBrandColor);
				document.documentElement.style.setProperty('--brand-primary-text-color', textColor);
				
				// Update Vuetify theme if available
				if (this.$vuetify && this.$vuetify.theme && this.$vuetify.theme.themes && this.$vuetify.theme.themes.light) {
					this.$vuetify.theme.themes.light.primary = this.primaryBrandColor;
				}
			}
		},
		
		loadEmailTemplates() {
			// Load email templates from organization
			if (this.organization) {
				// Load guest invite templates (check both old and new field names)
				this.emailTemplates.guestInvite_subject = this.organization.guestInvite_subject || this.organization.subject || this.defaultEmailTemplates.guestInvite.subject;
				this.emailTemplates.guestInvite_header = this.organization.guestInvite_header || this.organization.header || this.defaultEmailTemplates.guestInvite.header;
				this.emailTemplates.guestInvite_body = this.organization.guestInvite_body || this.organization.body || this.defaultEmailTemplates.guestInvite.body;
				
				// Load member invite templates
				this.emailTemplates.memberInvite_subject = this.organization.memberInvite_subject || this.defaultEmailTemplates.memberInvite.subject;
				this.emailTemplates.memberInvite_body = this.organization.memberInvite_body || this.defaultEmailTemplates.memberInvite.body;
				
				// Load task reminder templates
				this.emailTemplates.taskReminder_subject = this.organization.taskReminder_subject || this.defaultEmailTemplates.taskReminder.subject;
				this.emailTemplates.taskReminder_intro = this.organization.taskReminder_intro || this.defaultEmailTemplates.taskReminder.intro;
				this.emailTemplates.taskReminder_closing = this.organization.taskReminder_closing || this.defaultEmailTemplates.taskReminder.closing;
				
				// Load notification templates
				this.emailTemplates.notification_subject = this.organization.notification_subject || this.defaultEmailTemplates.notification.subject;
				this.emailTemplates.notification_body = this.organization.notification_body || this.defaultEmailTemplates.notification.body;
				
				// Load magic link templates
				this.emailTemplates.magicLink_subject = this.organization.magicLink_subject || this.defaultEmailTemplates.magicLink.subject;
				this.emailTemplates.magicLink_body = this.organization.magicLink_body || this.defaultEmailTemplates.magicLink.body;
				this.emailTemplates.magicLink_expiry = this.organization.magicLink_expiry || this.defaultEmailTemplates.magicLink.expiry;
			}
		},
		
		resetEmailTemplate(templateType) {
			// Reset specific email template to default
			switch(templateType) {
				case 'guestInvite':
					this.emailTemplates.guestInvite_subject = this.defaultEmailTemplates.guestInvite.subject;
					this.emailTemplates.guestInvite_header = this.defaultEmailTemplates.guestInvite.header;
					this.emailTemplates.guestInvite_body = this.defaultEmailTemplates.guestInvite.body;
					break;
				case 'memberInvite':
					this.emailTemplates.memberInvite_subject = this.defaultEmailTemplates.memberInvite.subject;
					this.emailTemplates.memberInvite_body = this.defaultEmailTemplates.memberInvite.body;
					break;
				case 'taskReminder':
					this.emailTemplates.taskReminder_subject = this.defaultEmailTemplates.taskReminder.subject;
					this.emailTemplates.taskReminder_intro = this.defaultEmailTemplates.taskReminder.intro;
					this.emailTemplates.taskReminder_closing = this.defaultEmailTemplates.taskReminder.closing;
					break;
				case 'notification':
					this.emailTemplates.notification_subject = this.defaultEmailTemplates.notification.subject;
					this.emailTemplates.notification_body = this.defaultEmailTemplates.notification.body;
					break;
				case 'magicLink':
					this.emailTemplates.magicLink_subject = this.defaultEmailTemplates.magicLink.subject;
					this.emailTemplates.magicLink_body = this.defaultEmailTemplates.magicLink.body;
					this.emailTemplates.magicLink_expiry = this.defaultEmailTemplates.magicLink.expiry;
					break;
			}
			this.notification('success', 'Template reset to default');
		},
		
		async saveAllEmailTemplates() {
			this.buttonSaving.updateEmailTemplates = true;
			
			try {
				await orgService.mutation("updateEmailTemplates", {
					guestInvite_subject: this.emailTemplates.guestInvite_subject,
					guestInvite_header: this.emailTemplates.guestInvite_header,
					guestInvite_body: this.emailTemplates.guestInvite_body,
					memberInvite_subject: this.emailTemplates.memberInvite_subject,
					memberInvite_body: this.emailTemplates.memberInvite_body,
					taskReminder_subject: this.emailTemplates.taskReminder_subject,
					taskReminder_intro: this.emailTemplates.taskReminder_intro,
					taskReminder_closing: this.emailTemplates.taskReminder_closing,
					notification_subject: this.emailTemplates.notification_subject,
					notification_body: this.emailTemplates.notification_body,
					magicLink_subject: this.emailTemplates.magicLink_subject,
					magicLink_body: this.emailTemplates.magicLink_body,
					magicLink_expiry: this.emailTemplates.magicLink_expiry
				});
				
				this.buttonSaving.updateEmailTemplates = false;
				this.notification('success', 'Email templates updated successfully');
				
				// Refresh organization data
				await this.getOrg();
			} catch (error) {
				this.buttonSaving.updateEmailTemplates = false;
				console.error("Error updating email templates:", error);
				this.notification('error', 'Failed to update email templates: ' + error.message);
			}
		},
		
		// Subdomain Management Methods
		async loadSubdomain() {
			try {
				if (!this.organization || !this.organization.id) {
					return;
				}
				
				console.log("Loading subdomain for organization:", this.organization.id);
				
				// Get PublicOrganization by org ID
				const publicOrg = await orgService.query("getPublicOrgById", {
					org_id: this.organization.id
				});
				
				console.log("PublicOrganization response:", publicOrg);
				
				if (publicOrg && publicOrg.subdomain) {
					this.subdomain = publicOrg.subdomain;
					this.originalSubdomain = publicOrg.subdomain;
					this.subdomainAvailable = true; // It's their own subdomain
					console.log("Loaded subdomain:", this.subdomain);
				} else {
					this.subdomain = "";
					this.originalSubdomain = "";
					this.subdomainAvailable = null;
					console.log("No subdomain set for this organization");
				}
			} catch (error) {
				console.error("Error loading subdomain:", error);
				this.subdomain = "";
				this.originalSubdomain = "";
				this.subdomainAvailable = null;
			}
		},
		
		onSubdomainInput() {
			// Clear any existing timeout
			if (this.subdomainCheckTimeout) {
				clearTimeout(this.subdomainCheckTimeout);
			}
			
			// Reset state
			this.subdomainAvailable = null;
			this.subdomainError = "";
			
			// Validate format first
			if (!this.subdomain || this.subdomain.trim() === "") {
				return;
			}
			
			const subdomain = this.subdomain.toLowerCase().trim();
			
			// Client-side validation
			if (!this.validateSubdomain(subdomain)) {
				this.subdomainError = "Use only letters and numbers (3-63 characters)";
				this.subdomainAvailable = false;
				return;
			}
			
			// If it's the original subdomain, it's available (they can keep it)
			if (subdomain === this.originalSubdomain) {
				this.subdomainAvailable = true;
				return;
			}
			
			// Debounce the availability check (500ms)
			this.subdomainCheckTimeout = setTimeout(() => {
				this.checkSubdomainAvailability();
			}, 500);
		},
		
		validateSubdomain(subdomain) {
			// Alphanumeric only, 3-63 characters
			const subdomainRegex = /^[a-z0-9]{3,63}$/;
			return subdomainRegex.test(subdomain);
		},
		
		async checkSubdomainAvailability() {
			if (!this.subdomain || this.subdomain.trim() === "") {
				return;
			}
			
			const subdomain = this.subdomain.toLowerCase().trim();
			
			// Validate format
			if (!this.validateSubdomain(subdomain)) {
				this.subdomainError = "Use only letters and numbers (3-63 characters)";
				this.subdomainAvailable = false;
				return;
			}
			
			try {
				this.checkingSubdomain = true;
				this.subdomainError = "";
				
				const available = await orgService.query("checkSubdomainAvailability", {
					subdomain: subdomain
				});
				
				this.subdomainAvailable = available;
				
				if (!available) {
					this.subdomainError = "This subdomain is already taken";
				}
			} catch (error) {
				console.error("Error checking subdomain availability:", error);
				this.subdomainError = "Error checking availability";
				this.subdomainAvailable = false;
			} finally {
				this.checkingSubdomain = false;
			}
		},
		
		async saveSubdomain() {
			try {
				this.buttonSaving.updateSubdomain = true;
				
				const subdomain = this.subdomain ? this.subdomain.toLowerCase().trim() : null;
				
				// Validate if subdomain is provided
				if (subdomain && !this.validateSubdomain(subdomain)) {
					this.notification('error', 'Invalid subdomain format');
					this.buttonSaving.updateSubdomain = false;
					return;
				}
				
				// Check availability if changed
				if (subdomain && subdomain !== this.originalSubdomain && !this.subdomainAvailable) {
					this.notification('error', 'This subdomain is not available');
					this.buttonSaving.updateSubdomain = false;
					return;
				}
				
				// Call updatePublicOrganization mutation
				await orgService.mutation("updatePublicOrganization", {
					subdomain: subdomain
				});
				
				this.originalSubdomain = subdomain || "";
				this.buttonSaving.updateSubdomain = false;
				
				this.notification('success', `Subdomain ${subdomain ? 'updated to: ' + subdomain + '.zapaclientportal.com' : 'removed'} successfully`);
			} catch (error) {
				this.buttonSaving.updateSubdomain = false;
				console.error("Error updating subdomain:", error);
				this.notification('error', 'Failed to update subdomain: ' + error.message);
			}
		}
		
	},
	created() {
		this.logoBucket = awsmobile.aws_org_logos_s3_bucket;
	},
	mounted() {

		if (this.$route.query.updated === 'true' || this.$route.query.register === 'true') {
			this.openSubscriptionTab = true;
			this.tabs = this.subscriptionTabIndex;
		}

		if (this.$route.query.step) {
			try {
				this.tabs = Number(this.$route.query.step);
			} catch (error) {
				console.error("Unable to interpret requested step.");
			}
		}

		if (!this.newOrganizationTier || this.newOrganizationTier !== "null") {
			this.newOrganizationTier = "Professional";
		}
		this.init();
		this.loadTemplates();
		this.loadWorkflows();
		this.loadSubdomain();
		this.logoBucket = awsmobile.aws_org_logos_s3_bucket;
	},
	watch: {
		organization: {
			handler(newValue) {
				if (newValue) {
					this.loadEmailTemplates();
					this.loadSubdomain(); // Load subdomain when organization is available
				}
			},
			deep: true,
			immediate: true
		},
		subscriptionTabIndex(newValue) {
			// Tab visibility (e.g. Templates) can change after the org loads,
			// shifting the tab indices. Keep the Subscription tab selected when
			// it was requested via URL (?updated=true / ?register=true).
			if (this.openSubscriptionTab) {
				this.tabs = newValue;
			}
		}
	}
});


const toBase64 = file => new Promise((resolve, reject) => {
	const reader = new FileReader();
	reader.readAsArrayBuffer(file);
	reader.onload = () => {
		const bytes = new Uint8Array(reader.result);
		let binary = '';
		const chunkSize = 8192; // Process in 8KB chunks to avoid stack overflow
		
		for (let i = 0; i < bytes.length; i += chunkSize) {
			const chunk = bytes.subarray(i, Math.min(i + chunkSize, bytes.length));
			binary += String.fromCharCode.apply(null, chunk);
		}
		
		resolve(btoa(binary));
	};
	reader.onerror = error => reject(error);
});
